module.exports = __webpack_public_path__ + "static/media/menu_icon.47bf02f2.svg";